import { Flex, Typography } from '@aloft/toolkit-sui';

const MLSDataSimpleStatistic = ({ value, label }: { value?: string; label: string }) => (
  <Flex flexDirection="column" alignItems="center">
    <Typography variant="h2">{value ?? '-'}</Typography>
    <Flex marginTop="-6px">
      <Typography variant="body1" color="textTertiary">
        {label}
      </Typography>
    </Flex>
  </Flex>
);

export default MLSDataSimpleStatistic;
